import "core-js/modules/es.parse-int.js";
var _0x237fb6 = _0x2b05;

function _0x2b05(_0xab9841, _0x52cec6) {
  var _0x232a45 = _0x232a();

  return _0x2b05 = function _0x2b05(_0x2b05d1, _0x14c579) {
    _0x2b05d1 = _0x2b05d1 - 0xed;
    var _0x489c5a = _0x232a45[_0x2b05d1];
    return _0x489c5a;
  }, _0x2b05(_0xab9841, _0x52cec6);
}

(function (_0x37f9fe, _0x51a60f) {
  var _0x5b4767 = _0x2b05,
      _0x44ae61 = _0x37f9fe();

  while (!![]) {
    try {
      var _0x4eabc8 = -parseInt(_0x5b4767(0xfd)) / 0x1 * (parseInt(_0x5b4767(0xfb)) / 0x2) + -parseInt(_0x5b4767(0xf7)) / 0x3 * (parseInt(_0x5b4767(0xf2)) / 0x4) + -parseInt(_0x5b4767(0xed)) / 0x5 + parseInt(_0x5b4767(0xfc)) / 0x6 + -parseInt(_0x5b4767(0xee)) / 0x7 + parseInt(_0x5b4767(0x102)) / 0x8 + parseInt(_0x5b4767(0x100)) / 0x9;

      if (_0x4eabc8 === _0x51a60f) break;else _0x44ae61['push'](_0x44ae61['shift']());
    } catch (_0xb642e1) {
      _0x44ae61['push'](_0x44ae61['shift']());
    }
  }
})(_0x232a, 0xdd11d);

function _0x232a() {
  var _0x3ee239 = ['1751444gUZGAy', 'SET_GAME_TOKEN', 'checkedSkill', 'lsGetSkillList', 'stringify', '3qbLvlp', 'lsSetOpenId', 'SET_CHECKED_SKILL', 'openId', '2aGKJZr', '1145706WETnhI', '1670742HDYDUc', 'skillList', 'lsSetGameToken', '39114738yZCJLj', 'SET_SKILL_LIST', '5378368cWZpMG', '3726530UVQvyn', '10149433fybwwl', 'getTime', 'lsSetCheckedSkill', 'lsSetSkillList'];

  _0x232a = function _0x232a() {
    return _0x3ee239;
  };

  return _0x232a();
}

import { Encrypt } from '@/views/miniGame/encrypt_game';
import _0x2afdee from '@/utils/auth';
var state = {
  'openId': _0x2afdee['lsGetOpenId']() || null,
  'gameToken': _0x2afdee['lsGetGameToken']() || null,
  'skillList': _0x2afdee[_0x237fb6(0xf5)]() || [],
  'checkedSkill': _0x2afdee['lsGetCheckedSkill']() || {
    'engine': null,
    'spaceship': null
  }
},
    mutations = {
  'SET_OPEN_ID': function SET_OPEN_ID(_0xdd3dfc, _0x5580a0) {
    var _0x2b1b67 = _0x237fb6;
    _0x2afdee[_0x2b1b67(0xf8)](_0x5580a0), _0xdd3dfc[_0x2b1b67(0xfa)] = _0x5580a0;
  },
  'SET_GAME_TOKEN': function SET_GAME_TOKEN(_0x316ea8, _0x25439d) {
    var _0x224964 = _0x237fb6;
    _0x2afdee[_0x224964(0xff)](_0x25439d), _0x316ea8['gameToken'] = _0x25439d;
  },
  'SET_SKILL_LIST': function SET_SKILL_LIST(_0x152254, _0x52e29b) {
    var _0x2bd853 = _0x237fb6;
    _0x2afdee[_0x2bd853(0xf1)](_0x52e29b), _0x152254[_0x2bd853(0xfe)] = _0x52e29b;
  },
  'SET_CHECKED_SKILL': function SET_CHECKED_SKILL(_0x532e36, _0x1c126d) {
    var _0x200447 = _0x237fb6;
    _0x2afdee[_0x200447(0xf0)](_0x1c126d), _0x532e36[_0x200447(0xf4)] = _0x1c126d;
  }
},
    actions = {
  'setOpenId': function setOpenId(_ref, _0x24c1d7) {
    var _0x417049 = _ref.commit;

    _0x417049('SET_OPEN_ID', _0x24c1d7);
  },
  'setGameToken': function setGameToken(_ref2, _0x1cd35b) {
    var _0x3786fb = _ref2.commit;
    var _0x417723 = _0x237fb6;

    _0x3786fb(_0x417723(0xf3), _0x1cd35b);
  },
  'setSkillList': function setSkillList(_ref3, _0x451cf1) {
    var _0x139d9 = _ref3.commit;
    var _0x278923 = _0x237fb6;

    _0x139d9(_0x278923(0x101), _0x451cf1);
  },
  'setCheckedSkill': function setCheckedSkill(_ref4, _0x5017c3) {
    var _0x53fb91 = _ref4.commit;
    var _0x13d32a = _0x237fb6;

    _0x53fb91(_0x13d32a(0xf9), _0x5017c3);
  }
},
    getters = {
  'getSign': function getSign(_0x5bd418) {
    var _0x3c5d13 = _0x237fb6,
        _0x5dd5e6 = {
      'userId': _0x5bd418['openId'],
      'timestamp': new Date()[_0x3c5d13(0xef)]()
    };
    return Encrypt(JSON[_0x3c5d13(0xf6)](_0x5dd5e6));
  }
};
export default {
  'namespaced': !![],
  'state': state,
  'mutations': mutations,
  'actions': actions,
  'getters': getters
};